import { Component } from 'react';

export class FallbackBankSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                width="74"
                height="74"
                data-testid="FallbackBankSVG"
                viewBox="0 0 74 74"
            >
                <g filter="url(#filter0_d)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M28.1369 56.3487C43.6765 56.3487 56.2738 43.7346 56.2738 28.1744C56.2738 12.6141 43.6765 0 28.1369 0C12.5973 0 0 12.6141 0 28.1744C0 43.7346 12.5973 56.3487 28.1369 56.3487Z"
                        transform="translate(9 5)"
                        fill="white"
                        stroke="#DBDBDB"
                    />
                    <mask
                        id="mask0"
                        maskUnits="userSpaceOnUse"
                        x="8"
                        y="4"
                        width="58"
                        height="58"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M28.1369 56.3487C43.6765 56.3487 56.2738 43.7346 56.2738 28.1744C56.2738 12.6141 43.6765 0 28.1369 0C12.5973 0 0 12.6141 0 28.1744C0 43.7346 12.5973 56.3487 28.1369 56.3487Z"
                            transform="translate(9 5)"
                            fill="white"
                            stroke="white"
                        />
                    </mask>
                    <g mask="url(#mask0)">
                        <path
                            d="M13.9403 0.00243899C13.8752 0.00913826 13.8115 0.02578 13.7514 0.0517761L0.387785 5.73541C0.272655 5.7839 0.174475 5.86498 0.105507 5.96852C0.03654 6.07206 -0.000156889 6.19347 5.04179e-07 6.31759V8.21213C1.73785e-05 8.37961 0.0670681 8.54023 0.186406 8.65866C0.305743 8.77709 0.467595 8.84363 0.636364 8.84365H4.77273V17.6849H2.86364C2.84376 17.6839 2.82385 17.6839 2.80398 17.6849C2.64575 17.6997 2.49883 17.7727 2.39211 17.8895C2.28539 18.0064 2.22659 18.1587 2.22727 18.3164V19.8952H0.636364C0.467595 19.8952 0.305743 19.9617 0.186406 20.0801C0.0670681 20.1986 1.73701e-05 20.3592 5.04179e-07 20.5267V23.3685C1.73701e-05 23.536 0.0670681 23.6966 0.186406 23.815C0.305743 23.9334 0.467595 24 0.636364 24H27.3636C27.5324 24 27.6943 23.9334 27.8136 23.815C27.9329 23.6966 28 23.536 28 23.3685V20.5267C28 20.3592 27.9329 20.1986 27.8136 20.0801C27.6943 19.9617 27.5324 19.8952 27.3636 19.8952H25.7727V18.3164C25.7727 18.1489 25.7057 17.9883 25.5863 17.8698C25.467 17.7514 25.3051 17.6849 25.1364 17.6849H23.2273V8.52789C23.2286 8.4433 23.2128 8.3593 23.1808 8.28089C23.1488 8.20247 23.1012 8.13124 23.0409 8.07141C22.9807 8.01159 22.9089 7.9644 22.8299 7.93263C22.7508 7.90087 22.6662 7.88518 22.581 7.88651C22.4974 7.8878 22.4149 7.90542 22.3382 7.93835C22.2615 7.97128 22.1921 8.01889 22.1339 8.07845C22.0757 8.13801 22.0299 8.20835 21.9992 8.28547C21.9684 8.36258 21.9532 8.44496 21.9545 8.52789V17.6849H20.6818V8.84365H27.3636C27.5324 8.84363 27.6943 8.77709 27.8136 8.65866C27.9329 8.54023 28 8.37961 28 8.21213V6.31759C28.0002 6.19347 27.9635 6.07206 27.8945 5.96852C27.8255 5.86498 27.7273 5.7839 27.6122 5.73541L14.2486 0.0517761C14.1516 0.0101866 14.0456 -0.00676929 13.9403 0.00243899ZM14 1.32467L26.7273 6.73202V7.58062H1.27273V6.73202L14 1.32467ZM6.04545 8.84365H7.31818V17.6849H6.04545V8.84365ZM8.59091 8.84365H12.0909V17.6849H8.59091V8.84365ZM13.3636 8.84365H14.6364V17.6849H13.3636V8.84365ZM15.9091 8.84365H19.4091V17.6849H15.9091V8.84365ZM3.5 18.9479H24.5V20.5267C24.5 20.6942 24.5671 20.8548 24.6864 20.9732C24.8057 21.0916 24.9676 21.1582 25.1364 21.1582H26.7273V22.737H1.27273V21.1582H2.86364C3.03241 21.1582 3.19426 21.0916 3.3136 20.9732C3.43293 20.8548 3.49998 20.6942 3.5 20.5267V18.9479Z"
                            transform="translate(23 20)"
                            fill="#1F4264"
                        />
                    </g>
                </g>
                <defs>
                    <filter
                        id="filter0_d"
                        x="0.5"
                        y="0.5"
                        width="73.2738"
                        height="73.3487"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 255 0"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="4" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow"
                            result="shape"
                        />
                    </filter>
                </defs>
            </svg>
        );
    }
}
